import React from 'react';
import Icon from '../../../components/AppIcon';

const FeesTab = ({ institution }) => {
  return (
    <div className="space-y-6">
      {/* Tuition Fees */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Frais de scolarité
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {institution?.tuitionFees?.map((program, index) => (
            <div key={index} className="border border-border rounded-lg p-4">
              <h4 className="font-medium text-foreground mb-3">{program?.program}</h4>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Frais annuels</span>
                  <span className="font-medium text-foreground">{program?.annual} MAD</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Frais d'inscription</span>
                  <span className="font-medium text-foreground">{program?.registration} MAD</span>
                </div>
                <div className="flex justify-between border-t border-border pt-2">
                  <span className="font-medium text-foreground">Total première année</span>
                  <span className="font-semibold text-primary">{program?.total} MAD</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Additional Costs */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Coûts additionnels
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {institution?.additionalCosts?.map((cost, index) => (
            <div key={index} className="flex items-center gap-3 p-4 border border-border rounded-lg">
              <Icon name={cost?.icon} size={20} className="text-accent" />
              <div>
                <div className="font-medium text-foreground">{cost?.item}</div>
                <div className="text-sm text-muted-foreground">{cost?.cost} MAD</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Payment Plans */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Plans de paiement
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {institution?.paymentPlans?.map((plan, index) => (
            <div key={index} className="border border-border rounded-lg p-4">
              <div className="flex items-center gap-2 mb-3">
                <Icon name="CreditCard" size={20} className="text-primary" />
                <h4 className="font-medium text-foreground">{plan?.name}</h4>
              </div>
              <p className="text-sm text-muted-foreground mb-3">{plan?.description}</p>
              <div className="space-y-2">
                {plan?.installments?.map((installment, instIndex) => (
                  <div key={instIndex} className="flex justify-between text-sm">
                    <span className="text-muted-foreground">{installment?.period}</span>
                    <span className="font-medium text-foreground">{installment?.amount} MAD</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Financial Aid */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Aides financières disponibles
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {institution?.financialAid?.map((aid, index) => (
            <div key={index} className="flex items-start gap-3 p-4 border border-border rounded-lg">
              <Icon name="Gift" size={20} className="text-success mt-1" />
              <div>
                <h4 className="font-medium text-foreground">{aid?.name}</h4>
                <p className="text-sm text-muted-foreground mt-1">{aid?.description}</p>
                <div className="text-sm font-medium text-success mt-2">
                  Jusqu'à {aid?.amount} MAD
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeesTab;